module.exports = (__webpack_require__(24))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/warning/warning.js from dll-reference lib_core
// module id = 51
// module chunks = 110